export default function DynamicLoader({ classname}) {
    return (
        <div className={classname} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div className="lds-heart"><div></div></div>
        </div>
    );
}